export default __webpack_public_path__ + "static/media/camera2.33cafd59.svg";